import { render, staticRenderFns } from "./StudentHistorySidebar.vue?vue&type=template&id=3ec73bf0&scoped=true&lang=pug&"
import script from "./StudentHistorySidebar.vue?vue&type=script&lang=ts&"
export * from "./StudentHistorySidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistorySidebar.vue?vue&type=style&index=0&id=3ec73bf0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec73bf0",
  null
  
)

export default component.exports